import React from 'react'
    import { Routes, Route } from 'react-router-dom'
    import Navbar from './components/Navbar'
    import Footer from './components/Footer'
    import Home from './pages/Home'
    import Services from './pages/Services'
    import Industries from './pages/Industries'
    import About from './pages/About'
    import Contact from './pages/Contact'

    function App() {
      return (
        <div className="min-h-screen bg-white" data-component-path="src/App.jsx" data-component-line="1:4" data-component-id="src/App.jsx:1:4">
          <Navbar />
          <main data-component-path="src/App.jsx" data-component-line="2:6" data-component-id="src/App.jsx:2:6">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/industries" element={<Industries />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
        </div>
      )
    }

    export default App